export function formatElapsedSessionTicker(secondsInput = 0) {
  const totalSeconds = Math.max(0, Math.floor(Number(secondsInput) || 0))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
